<template>
  <div>
    <!-- 系统设置修改密码 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>修改密码</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="formItem">
      <el-form
        :model="ruleForm"
        status-icon
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item class="userItem" label="用户名:" prop="pass">
          <el-input v-model="ruleForm.userName" disabled></el-input>
        </el-form-item>
        <el-form-item label="旧密码:">
          <span class="xingA">*</span>
          <el-input type="password" v-model="ruleForm.oldPassWord"></el-input>
        </el-form-item>
        <el-form-item label="新密码:">
          <span class="xingB">*</span>
          <el-input type="password" v-model="ruleForm.newPassWord"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码:">
          <span class="xingC">*</span>
          <el-input type="password" v-model="ruleForm.againPassWord"></el-input>
        </el-form-item>
        <div class="itemBtn">
          <el-form-item>
            <el-button type="primary" @click="submitForm()">确认修改</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { adminUpdatePwdPost } from "@/request/set.js";
export default {
  data() {
    return {
      // 表单绑定数据
      ruleForm: {
        userName: "",
        oldPassWord: "",
        newPassWord: "",
        againPassWord: ""
      },
      // 确认修改传参
      ruleFormPar: {
        token: "",
        old_pwd: "",
        new_pwd: "",
        confirm_pwd: ""
      },
      userName: "", // 用户名
      Token: ""
    };
  },
  mounted() {
    this.Token = window.sessionStorage.getItem("Token");
    this.userName = JSON.parse(window.localStorage.getItem("user"));
    console.log( this.userName?this.userName.user:'admin')
    this.ruleForm = {
      userName: this.userName?this.userName.user:'admin',
      oldPassWord: "",
      newPassWord: "",
      againPassWord: ""
    };
  },
  methods: {
    submitForm() {
      if(this.ruleForm.oldPassWord==''){
        this.$message.error('请输入旧密码')
            return false
      }
      if(this.ruleForm.newPassWord==''){
        this.$message.error('请输入新密码')
            return false
      }
      if(this.ruleForm.againPassWord==''){
        this.$message.error('请输入确认新密码')
            return false
      }
      if(this.ruleForm.newPassWord&this.ruleForm.againPassWord){
         if(this.ruleForm.newPassWord!=this.ruleForm.againPassWord){
            this.$message.error('两次密码输入不一致')
            return false
         }
      }
      this.ruleFormPar = {
        token: this.Token,
        old_pwd: this.ruleForm.oldPassWord,
        new_pwd: this.ruleForm.newPassWord,
        confirm_pwd: this.ruleForm.againPassWord
      };

      adminUpdatePwdPost(this.ruleFormPar).then(res => {
        if (res.data.rcode == 200) {
          this.$message.success(res.data.msg);
          this.ruleForm = {
            userName: this.userName.user,
            oldPassWord: "",
            newPassWord: "",
            againPassWord: ""
          };
        } else {
          this.$message.error(res.data.msg);
        }
      });
    }
  }
};
</script>

<style lang='less' scoped>
.el-form-item {
  position: relative;
}
.xingA {
  position: absolute;
  top: 2px;
  left: -66px;
  color: #ff4d4f;
}
.xingB {
  position: absolute;
  top: 2px;
  left: -66px;
  color: #ff4d4f;
}
.xingC {
  position: absolute;
  top: 2px;
  left: -92px;
  color: #ff4d4f;
}
.formItem {
  width: 400px;
  height: 300px;
  padding: 50px 40px 80px;
  background: #ffffff;
  margin: 150px auto;
  .itemBtn {
    display: flex;
    justify-content: center;
  }
  .userItem {
    /deep/.el-input__inner {
      -webkit-appearance: none;
      background-color: #fff;
      border-radius: 4px;
      border: 1px solid #ffffff;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      height: 40px;
      line-height: 40px;
      outline: 0;
      padding: 0 15px;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100%;
    }
  }
}
/deep/.el-form-item {
  margin-bottom: 20px;
}
/deep/.el-button {
  width: 100px;
  height: 40px;
  background: #006afa;
  border-radius: 4px;
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  /* identical to box height */
  text-align: center;
  color: #ffffff;
  margin-top: 42px;
  margin-left: -100px;
}
</style>